import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import moment from 'moment';
import { Endpoints, ServerResponseCurrencyKeys, ServerResponseKeys } from '../../../api/Constants';
import { setCoin, setLoyalty, setPremium } from '../../actions/extras';
import { setRewardCenterBaseUrl } from '../../actions/rewardCenter';
import { handleQueryLoggerEvents } from '../../sagas/handleLoggerErrorEvents';
import { setCurrentLevelBonusCoins, setLevel, setMaxBet, setNextLevelBonusCoins, setNextLevelMaxBet, setPreviousLevelBonusCoins } from '../../slices/level/level';
import { setXp, setXpRequired } from '../../slices/xp/xp';
import store from '../../store';

var formatLoyaltyExpiry = function formatLoyaltyExpiry(loyaltyExpiryDate) {
  var expiryDate = moment(loyaltyExpiryDate).format('DD MMM YYYY');
  return expiryDate;
};

export var postRewardCenterMutation = {
  query: function query() {
    return {
      url: Endpoints.INIT_REWARDS
    };
  },
  providesTags: ['RewardCenter'],
  transformResponse: function () {
    var _transformResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
      var RewardsImageBaseURL, callResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              RewardsImageBaseURL = store.getState().app.assetsUrls.RewardsImageBaseURL;
              callResponse = response[ServerResponseKeys.CALL_RESPONSE];
              Object.values(callResponse.offers).forEach(function (offer, index) {
                callResponse.offers[index].thumb = "".concat(RewardsImageBaseURL).concat(offer.thumb);
                var endtime = new Date(callResponse.offers[index].endtime);
                if (endtime && !isNaN(endtime)) callResponse.offers[index].endtime = endtime.getTime();
              });
              callResponse.offers = _toConsumableArray(Object.values(callResponse.offers));
              callResponse.filterList = _toConsumableArray(Object.values(callResponse.filterList));
              callResponse.propertyList = [{
                propertyId: -1,
                propertyName: 'All'
              }].concat(_toConsumableArray(Object.values(callResponse.propertyList)));
              callResponse.sortingRules = Object.values(callResponse.sortingRules);
              callResponse.profile = Object.values(callResponse.profile)[0] || {};
              callResponse.profile.loyaltyExpiryDate = formatLoyaltyExpiry(callResponse.profile.loyaltyExpiryDate);
              store.dispatch(setRewardCenterBaseUrl(RewardsImageBaseURL));
              return _context.abrupt("return", response);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function transformResponse(_x) {
      return _transformResponse.apply(this, arguments);
    }

    return transformResponse;
  }(),
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args, _ref) {
      var dispatch, queryFulfilled, _yield$queryFulfilled, data, balance, level, xp, progression;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch = _ref.dispatch, queryFulfilled = _ref.queryFulfilled;
              _context2.prev = 1;
              _context2.next = 4;
              return queryFulfilled;

            case 4:
              _yield$queryFulfilled = _context2.sent;
              data = _yield$queryFulfilled.data;
              balance = data[ServerResponseKeys.CURRENCY_BALANCES];
              level = data[ServerResponseKeys.LEVEL];
              xp = data[ServerResponseKeys.XP];
              progression = data[ServerResponseKeys.PROGRESSION];
              console.log("[EXTRAS UPDATE] ".concat(balance, " ").concat(level, " ").concat(xp));
              dispatch(setCoin(parseInt(balance[ServerResponseCurrencyKeys.COINS])));
              dispatch(setPremium(balance[ServerResponseCurrencyKeys.PREMIUM]));
              dispatch(setLoyalty(parseInt(balance[ServerResponseCurrencyKeys.LOYALTY])));
              dispatch(setLevel(progression.level));
              dispatch(setXp(progression.xp));
              dispatch(setXpRequired(progression.xpneeded));
              dispatch(setMaxBet(progression.maxbet));
              dispatch(setNextLevelMaxBet(progression.nextLevelMaxbet));
              dispatch(setNextLevelBonusCoins(progression.nextLevelCoins));
              dispatch(setCurrentLevelBonusCoins(progression.coins));
              dispatch(setPreviousLevelBonusCoins(progression.previousLevelCoins));
              _context2.next = 27;
              break;

            case 24:
              _context2.prev = 24;
              _context2.t0 = _context2["catch"](1);
              handleQueryLoggerEvents(_context2.t0);

            case 27:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 24]]);
    }));

    function onQueryStarted(_x2, _x3) {
      return _onQueryStarted.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};